/**
 * Display a spinner over some element.
 * @constructor
 * @implements {Foundation.View.Interface.Spinner}
 * @param {jQuerySelector=} selector
 * @param {Object.<string,*>=} options
 */
Foundation.View.Desktop.Spinner = function (selector, options) {
    /** @type {Object.<string,(number|string)>} */
    this.options = Foundation.extend({
        "img_src": "/foundation/images/loaders/spinner-white-on-black.gif",
        "color": "#000000",
        "opacity": .75,
        "width": 100,
        "height": 100,
        "img_width": 32,
        "img_height": 32,
        "borderRadius": 15,
        "delay": 0.1
    }, options || {});

    // Grab the element for the content that is loading. This is the element
    // we're going to try to display the loader over. If the selector specified
    // is null, then we're doing a full page loader.
    if (selector) {
        Foundation.documentReady.then(function () {
            /** @type {jQuery} */
            this.content = jQuery(selector);

            // Determine our z-index now. Waiting until .show() is
            // called may result in the spinner appearing over
            // an overlay.
            this.zIndex = Foundation.View.highestZIndexFor("body");
        }.bind(this));
    }

    // Show the loader after a delay.
    this.timer = new Foundation.Timer(this.options["delay"] * 1000);
    this.timer.then(this.show.bind(this));
};

Foundation.View.Desktop.Spinner.prototype.show = function () {
    Foundation.documentReady.then(function () {
        // Don't inject more than one spinner element into the DOM.
        if (this.spinner) return;

        // Handle whole page loader case first.
        if (!this.content) {
            jQuery.fancybox.showActivity();
            return;
        }

        var o = this.options;

        // Create the img and div elements for the spinner.
        var img = jQuery("<img>").attr("src", o["img_src"]).attr("alt", "Loading…");
        this.spinner = jQuery("<div></div>").append(img);

        // Get position of the element we're placing the spinner over.
        var elem = this.content.is(":visible") ? this.content : this.content.parent();
        var contentPos = elem.offset();
        var contentWidth = elem.outerWidth(true);
        var contentHeight = elem.outerHeight(true);

        // Set the spinner img styles.
        img.css({
            "display": "block",
            "position": "absolute",
            "width": `${o["img_width"]}px`,
            "height": `${o["img_height"]}px`,
            "left": `${Math.floor((o["width"] / 2) - (o["img_width"] / 2))}px`,
            "top": `${Math.floor((o["height"] / 2) - (o["img_height"] / 2))}px`
        });

        // The spinner div styles.
        this.spinner.css({
            "display": "block",
            "position": "absolute",
            "backgroundColor": o["color"],
            "opacity": o["opacity"],
            "width": `${o["width"]}px`,
            "height": `${o["height"]}px`,
            "left": `${Math.floor(contentPos["left"] + (contentWidth / 2) - (o["width"] / 2))}px`,
            "top": `${Math.floor(contentPos["top"] + (contentHeight / 2) - (o["height"] / 2))}px`,
            "zIndex": this.zIndex,
            "borderRadius": `${o["borderRadius"]}px`,
            "MozBorderRadius": `${o["borderRadius"]}px`,
            "WebkitBorderRadius": `${o["borderRadius"]}px`
        });

        jQuery(document.body).prepend(this.spinner);
    }.bind(this));
};

Foundation.View.Desktop.Spinner.prototype.hide = function () {
    this.timer.cancel();

    Foundation.documentReady.then(function () {
        if (this.spinner) {
            this.spinner.remove();
            this.spinner = null;
        }

        jQuery.fancybox.hideActivity();
    }.bind(this));
};
